import React from 'react';
import { isRTL } from '../../utils/rtl';
import { Badge } from './badge';

interface RTLIndicatorProps {
  language: string;
  className?: string;
}

/**
 * Visual indicator to show when RTL mode is active
 */
export const RTLIndicator: React.FC<RTLIndicatorProps> = ({ 
  language, 
  className = "" 
}) => {
  const isRTLLang = isRTL(language);
  
  if (!isRTLLang) {
    return null;
  }
  
  return (
    <Badge 
      variant="secondary" 
      className={`bg-blue-100 text-blue-800 border border-blue-200 ${className}`}
    >
      RTL Mode Active
    </Badge>
  );
}; 